import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import {
  CreateUserReducer,
  GetUserProjectReducer,
  RecoverPasswordUserReducer,
  ResendEmailUserReducer,
  SearchCompanyUserReducer,
  SearchSpecifyUserReducer,
  SearchUsersReducer,
  SignReducer,
  UpdateAdminUserReducer,
  UpdateUserReducer,
} from './reducer/user';
import {
  CompanyReducer,
  SearchCompanyReducer,
  SearchSpecifyCompanyReducer,
  UpdateCompanyReducer,
} from './reducer/company';
import {
  DeleteProjectReducer,
  GetProjectReducer,
  ProjectReducer,
  SearchProjectByMonthReducer,
  SearchProjectReducer,
  SearchUserProjectReducer,
  UpdateProjectReducer,
} from './reducer/project';
import { SendEmailReducer } from './reducer/email';
import {
  CreateClientsProjectsReducer,
  SearchClientsProjectsReducer,
  SearchSpecifyClientsProjectsReducer,
  UpdateClientsProjectsReducer,
} from './reducer/clientsProjects';
import {
  CreateLinksSystemReducer,
  SearchLinksSystemReducer,
  SearchSpecifyLinksSystemReducer,
  UpdateLinksSystemReducer,
} from './reducer/linksSystem';

const initialState = {
  userSign: {
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
    localFiles: localStorage.getItem('localFiles') ? JSON.parse(localStorage.getItem('localFiles')) : null,
  },
};
const reducer = combineReducers({
  userSign: SignReducer,
  createUser: CreateUserReducer,
  createCompany: CompanyReducer,
  searchCompany: SearchCompanyReducer,
  createProject: ProjectReducer,
  listProject: GetProjectReducer,
  searchProject: SearchProjectReducer,
  getUserProject: GetUserProjectReducer,
  updateProject: UpdateProjectReducer,
  sendEmail: SendEmailReducer,
  searchUsers: SearchUsersReducer,
  updateUser: UpdateUserReducer,
  recoverPasswordUser: RecoverPasswordUserReducer,
  searchSpecifyCompany: SearchSpecifyCompanyReducer,
  updateCompany: UpdateCompanyReducer,
  searchSpecifyUser: SearchSpecifyUserReducer,
  updateAdminUser: UpdateAdminUserReducer,
  deleteProject: DeleteProjectReducer,
  searchCompanyUser: SearchCompanyUserReducer,
  searchUserProject: SearchUserProjectReducer,
  resendEmailUser: ResendEmailUserReducer,
  searchProjectByMonth: SearchProjectByMonthReducer,
  createClientsProjects: CreateClientsProjectsReducer,
  searchClientsProjects: SearchClientsProjectsReducer,
  searchSpecifyClientsProjects: SearchSpecifyClientsProjectsReducer,
  updateClientsProjects: UpdateClientsProjectsReducer,
  createLinksSystem: CreateLinksSystemReducer,
  searchLinksSystem: SearchLinksSystemReducer,
  searchSpecifyLinksSystem: SearchSpecifyLinksSystemReducer,
  updateLinksSystem: UpdateLinksSystemReducer,
});

const composeEnhacer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducer, initialState, composeEnhacer(applyMiddleware(thunk)));

export default store;
